/**
 * The four signal tones, as the classes a component needs to paint one.
 *
 * A signal is ink, not paint: the `word` is the tone's ink colour, the `rail` is its 3px
 * line down the left edge of a white surface, and the `chip` is the one place the tint is
 * allowed — a small uppercase word with a dot. Nothing here is a pastel banner; that's the
 * point (docs/design-language.md).
 *
 *   warn  copper  time slipping, needs a look
 *   stop  claret  money, food or safety waiting; errors; allergies
 *   ok    moss    done, seated, paid
 *   info  navy    neutral notices, sent, confirmed
 */
export const TONES = {
  warn: {
    word: "text-signal-warn",
    rail: "border-l-signal-warn-line",
    line: "border-signal-warn-line",
    dot: "bg-signal-warn-line",
    tint: "bg-signal-warn-tint",
    chip: "text-signal-warn border-signal-warn-line bg-signal-warn-tint",
  },
  stop: {
    word: "text-signal-stop",
    rail: "border-l-signal-stop-line",
    line: "border-signal-stop-line",
    dot: "bg-signal-stop-line",
    tint: "bg-signal-stop-tint",
    chip: "text-signal-stop border-signal-stop-line bg-signal-stop-tint",
  },
  ok: {
    word: "text-signal-ok",
    rail: "border-l-signal-ok-line",
    line: "border-signal-ok-line",
    dot: "bg-signal-ok-line",
    tint: "bg-signal-ok-tint",
    chip: "text-signal-ok border-signal-ok-line bg-signal-ok-tint",
  },
  info: {
    word: "text-signal-info",
    rail: "border-l-signal-info-line",
    line: "border-signal-info-line",
    dot: "bg-signal-info-line",
    tint: "bg-signal-info-tint",
    chip: "text-signal-info border-signal-info-line bg-signal-info-tint",
  },
};

export const TONE_NAMES = Object.keys(TONES);

/** The classes for `tone`, falling back to `info` for anything unknown. */
export function tone(name) {
  return TONES[name] || TONES.info;
}
